import Serializable from "@/core/misc/mixins/Serializable";

class PartnerCategory extends Serializable {
    id: number | string;
    name: string;

    static fromServer(data: any, result = new PartnerCategory()): PartnerCategory {
        super.fromServer(data, result);
        return result;
    }
}

export default PartnerCategory;